import React, { useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";

import { Button, Form, Header, Icon, Message, Modal } from "semantic-ui-react";
import { message } from "antd";
import axios from "axios";

function ResetRequest({ open, onClose }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    email: false,
  });
  const [showMessage] = useState({ show: false, message: "" });

  const history = useHistory();
  // const { state = {} } = props.location;
  // const { prevLocation } = state;
  const { state } = useLocation();

  const handleResetRequest = async () => {
    try {
      // check if email is valid
      if (
        !email ||
        !new RegExp(/^[a-z0-9._-]+@[a-z0-9.-]+\.[a-z]{2,4}$/).test(email)
      )
        return setErrors({ ...errors, email: true });
      // call api
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/users/reset-password/request`,
        { email }
      );
      // if status is 200
      if (response.status === 200) {
        setLoading(false);
        return history.push(`/auth/reset-password/verify`, { ...state, email });
        // return setMessage({
        //   show: !showMessage.show,
        //   message: `We have sent an email to ${email}, check your inbox to reset your password`,
        // });
      }
      // return good response
    } catch (error) {
      setLoading(false);
      if (error.message === "Network Error") {
        return message.error(error.message);
      }
      if (error?.response?.status === 404) {
        return message.error(error.response.data.error);
      }
      if (error?.response?.status === 500) {
        return message.error(error.response.data.error);
      }
    }
  };

  return (
    <Modal
      closeIcon
      open={open}
      onClose={onClose}
      centered
      dimmer="inverted"
      size="tiny"
      style={{
        position: "relative",
        height: "32vh",
      }}
    >
      <Header icon="repeat" content="Reset Password" textAlign="center" />
      <Modal.Content>
        {!showMessage.show ? (
          <Form>
            <Form.Input
              fluid
              icon="mail"
              iconPosition="left"
              placeholder="E-mail address"
              error={
                errors.email
                  ? {
                      content: "Please enter a valid email address",
                      pointing: "below",
                    }
                  : false
              }
              onChange={(e) => {
                setEmail(e.target.value);
                setErrors({ ...errors, email: false });
              }}
            />
          </Form>
        ) : (
          <Message success>
            {showMessage.message}
            <Link to={{ pathname: "/auth/reset-password/verify", state }}>
              <Button basic content="OK" />
            </Link>
          </Message>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button color="red" circular onClick={onClose}>
          <Icon name="remove" /> Cancel
        </Button>
        <Button
          color="dodge blue"
          circular
          loading={loading}
          onClick={handleResetRequest}
        >
          <Icon name="checkmark" /> Send email
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default ResetRequest;
